<div [hidden]="isHidden" [ngClass]="className">
  <span class="closeNotification" (click)="hide()">&times;</span>
  <img _ngcontent-c7="" class="navIcon" [src]="loadImage()" />
    <!--medptImageLoader
    [imageName]="loadImage(className)"
    [folderPath]="sharedImagesPath"-->
  
  <div class="notificationText">{{ message }}</div>
</div>
